import {
  Backend,
  Options,
  Transport,
  Event,
  NoopTransport,
} from "@jupiter/types";

export type BackendClass<B extends Backend, O extends Options> = new (
  options: O
) => B;

export abstract class BaseBackend<O extends Options> implements Backend {
  protected readonly _options: O;

  protected readonly _transport: Transport;

  public constructor(options: O) {
    this._options = options;
    this._transport = this._setupTransport();
  }

  public sendEvent(event: Event) {
    return this._transport.sendEvent(event);
  }

  protected _setupTransport(): Transport {
    return new NoopTransport();
  }
}
